export enum OrderLineStatus {
  TO_PLAN = 'TO_PLAN',
  PLANNED = 'PLANNED',
  PRODUCED = 'PRODUCED',
  PARTIALLY_PLANNED = 'PARTIALLY_PLANNED',
  CANCELLED = 'CANCELLED'
}

export namespace OrderLineStatus {
  export function getOrderLineStatusClass(orderLineStatus: OrderLineStatus): string {
    return OrderLineStatus[orderLineStatus].replace('_', '-').toLowerCase();
  }
}
